import React from 'react'
import injectStyles from 'react-jss'
import { theme } from '../../../../../../../../Assets/Styles/theme'
import { styles } from './styles'

const Tabs = ({ tabs, classes }) => {
  return (
    <div className={classes.container}>
      {tabs.map(tab => {
        return (
          <div
            onClick={tab.onClick}
            className={classes.tab}
            style={{
              borderBottom: tab.isActive
                ? `4px solid ${theme.colors.primary}`
                : null,
              marginBottom: tab.isActive ? -2 : 0,
              paddingBottom: tab.isActive ? 14 : 12,
            }}
          >
            {tab.label}
          </div>
        )
      })}
    </div>
  )
}

export default injectStyles(styles)(Tabs)
